import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  deleteGhatReceipt,
  findAllGhatReceipt,
} from "./services/gharteceipt.services";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import {
  clearFilterGhatReceipt,
  clearGhatReceiptDetail,
  setFilterGhatReceipt,
  setGhatReceiptID,
} from "./ghatReceiptSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  GridCellProps,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
  GridPageChangeEvent,
  GridCustomFilterCellProps,
} from "@progress/kendo-react-grid";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import IconButton from "../../components/common/IconButton";
import { FiEdit } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import { LoadingPanel } from "../../components/layout/Loading";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import CommonFilterCell from "../../components/common/GlobalCommonFilterCell";
import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
  PRINT_ACCESS,
} from "../../_contstants/common";
import { FaEye } from "react-icons/fa";

const GhatReceipt: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);
  useEffect(() => {
    return () => {
      dispatch(setCurrentPage(0));
      dispatch(closeDialog());
      dispatch(clearGhatReceiptDetail());
    };
  }, []);

  const handleProcessCreate = () => {
    navigate("/ghatissuereceipt/create");
  };

  return (
    <>
      <DeleteGhatReceiptDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Ghat Receipts
          </Typography.h4>
          {isAddAccess && (
            <Button
              onClick={handleProcessCreate}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              Add New
            </Button>
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <GhatReceiptGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const GhatReceiptGridComponent: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const GhatReceiptList = useAppSelector(
    (state) => state.ghatreceipt.GhatReceiptList
  );
  const gridRef = useRef<any>(null);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const loading = useAppSelector((state) => state.ghatreceipt.loading);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);

  const FilterGhatReceipt = useAppSelector(
    (state) => state.ghatreceipt.FilterGhatReceipt
  );
  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  useEffect(() => {
    const payload = {
      ...FilterGhatReceipt,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    dispatch(findAllGhatReceipt(payload));
  }, [currentPage, pageLimit]);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleEditItem = (ghat_receipt_guid: number) => {
      navigate("/ghatissuereceipt/edit", {
        state: { ID: props.dataItem?.id, ghat_receipt_guid: ghat_receipt_guid },
      });
    };

    const handlePrint = (ghat_guid: string) => {
      window.open(`/ghatissuereceipt/${ghat_guid}`, "_blank");
    };

    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteGhatReceipt"));
      dispatch(setGhatReceiptID(ID));
    };

    return (
      <td className="action-td">
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            themeColor="success"
            onClick={() => handleEditItem(props.dataItem?.ghat_receipt_guid)}
          >
            <FiEdit
              className="absolute-position"
              style={{ fontSize: "20px" }}
            />
          </IconButton>
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            themeColor="error"
            onClick={() =>
              handleOpenDeleteDialog(props.dataItem.ghat_receipt_guid)
            }
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
        {isPrintAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="View"
            themeColor="tertiary"
            onClick={() => handlePrint(props.dataItem.ghat_receipt_guid)}
          >
            <FaEye className="absolute-position" style={{ fontSize: "24px" }} />
          </IconButton>
        )}
      </td>
    );
  };
  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 5 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const GhatReceiptFilterCell = React.useCallback(
    (props: GridCustomFilterCellProps) => (
      <CommonFilterCell
        {...props}
        filterSelector={(state) => state.ghatreceipt.FilterGhatReceipt}
        setFilterAction={setFilterGhatReceipt}
        clearFilterAction={clearFilterGhatReceipt}
        fetchDataAction={findAllGhatReceipt}
        pagination={{ case: "lowercase" }}
      />
    ),
    []
  );
  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <KendoGrid
        style={{ maxHeight: "calc(100vh - 152px)" }}
        scrollable="scrollable"
        filterable={true}
        filter={filter}
        data={filter ? filterBy(GhatReceiptList, filter) : GhatReceiptList}
        total={GhatReceiptList[0]?.itemcount || GhatReceiptList.length}
        onFilterChange={handleFilterChange}
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          field="receipt_no"
          title="Receipt No"
          cells={{
            data: (props: any) => (
              <td>
                <div
                  className="hoverableName"
                  onClick={() =>
                    navigate("/ghatissuereceipt/edit", {
                      state: {
                        ghat_receipt_guid: props.dataItem?.ghat_receipt_guid,
                      },
                    })
                  }
                >
                  {props.dataItem?.receipt_no}
                </div>
              </td>
            ),
          }}
        />
        <Column
          field="receipt_date"
          title="Receipt Date"
          cells={{ filterCell: GhatReceiptFilterCell }}
        />
        <Column
          field="karigar_name"
          title="Karigar Name"
          cells={{ filterCell: GhatReceiptFilterCell }}
        />
        {/* <Column
            field="ghat_receipt_guid"
            title="Status"
            cells={{data : MyActiveInActtiveCommandCell}}
            width={"90px"}
            filterable={false}
            locked={true}
          /> */}
        {(isDeleteAccess || isEditAccess) && (
          <Column
            field="ghat_receipt_guid"
            title="Actions"
            cells={{ data: MyEditCommandCell }}
            width={"150px"}
            filterable={false}
            locked={true}
          />
        )}
      </KendoGrid>
    </>
  );
};

const DeleteGhatReceiptDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const GhatReceiptID = useAppSelector(
    (state) => state.ghatreceipt.GhatReceiptID
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterGhatReceipt = useAppSelector(
    (state) => state.ghatreceipt.FilterGhatReceipt
  );
  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteGhatReceipt(ID));
      dispatch(setCurrentPage(0));
      const payload = {
        ...FilterGhatReceipt,
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      if (response.payload?.Data.Status === 200) {
        dispatch(findAllGhatReceipt(payload));
        dispatch(closeDialog());
        dispatch(clearGhatReceiptDetail());
      } else {
        dispatch(findAllGhatReceipt(payload));
        dispatch(closeDialog());
        dispatch(clearGhatReceiptDetail());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteGhatReceipt" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Ghat issue Receipt?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Ghat Issue Receipt?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => {
                    handleDeleteAction(GhatReceiptID);
                  }}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default GhatReceipt;
